var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.elemWidth + 1,"height":_vm.elemHeight + 1,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":_vm.elemWidth,"height":_vm.elemHeight,"stroke":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }